import { useMemo } from 'react';

import { Flex } from '@chakra-ui/react';

import { RatingRateProps } from './rating-rate.props';

export const RatingRate = ({ ratingAverage, size = 'md', ...props }: RatingRateProps) => {
    const fontSize = useMemo(() => {
        switch (size) {
            case 'lg':
                return {
                    box: {
                        base: 14,
                        md: 16,
                    },
                    rate: {
                        base: 'lg',
                        md: '2xl',
                    },
                };
            case 'sm':
                return {
                    box: 8,
                    rate: 'sm',
                };
            default:
                return {
                    box: {
                        base: 11,
                        md: 12,
                    },
                    rate: 'lg',
                };
        }
    }, [size]);

    return (
        <Flex
            backgroundColor={'secondary.solid'}
            color={'white'}
            justify={'center'}
            flex={'0 0 auto'}
            boxSize={fontSize.box}
            fontSize={fontSize.rate}
            alignItems={'center'}
            fontWeight={'bold'}
            borderRadius={4}
            lineHeight={1}
            data-testid="rating-average"
            as={'span'}
            {...props}
        >
            {ratingAverage < 10 ? ratingAverage.toFixed(1) : ratingAverage}
        </Flex>
    );
};
